<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <div class="font-semibold text-xl text-gray-800 leading-tight">
                    <inertia-link
                        class="text-indigo-500"
                        :href="route('admin.plans.index')"
                        >Plans</inertia-link
                    >
                    <samp class="mx-1">/</samp>
                    <samp>Content</samp>
                </div>
                <button
                    @click="open = true"
                    class="
                        py-1
                        px-2
                        bg-indigo-500
                        text-white
                        rounded
                        focus:outline-none
                    "
                >
                    Add
                </button>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        #
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            relative
                                                            px-6
                                                            py-3
                                                        "
                                                    >
                                                        <span class="sr-only"
                                                        >Edit</span
                                                        >
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Exercise Group
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Exercise Order
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Exercise
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Format
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Live
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Targets
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Category
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                                <tr
                                                    v-for="(
                                                        content, index
                                                    ) in contents"
                                                    :key="content.id"
                                                >
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-right text-sm
                                                            font-medium
                                                        "
                                                    >
                                                        <button
                                                            @click="destroy(plan, content)"
                                                            class="
                                                                text-red-400
                                                                hover:text-red-600
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Delete
                                                        </button>
                                                        <button
                                                            type="button"
                                                            @click="
                                                                edit(content)
                                                            "
                                                            class="
                                                                text-green-600
                                                                hover:text-green-900
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Edit
                                                        </button>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-sm
                                                            text-gray-500
                                                        "
                                                    >
                                                        {{ content.exercise_group }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-sm
                                                            text-gray-500
                                                        "
                                                    >
                                                        {{ content.exercise_order }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-60
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                        >
                                                            {{content.exercise ? content.exercise.title : ''}}
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-sm
                                                            text-gray-500
                                                        "
                                                    >
                                                        {{content.exercise ? content.exercise.format : ''}}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        <span
                                                            :class="{
                                                                'bg-green-100 text-green-800':
                                                                    content.live,
                                                                'bg-red-100 text-red-800':
                                                                    !content.live,
                                                            }"
                                                            class="
                                                                px-2
                                                                inline-flex
                                                                text-xs
                                                                leading-5
                                                                font-semibold
                                                                rounded-full
                                                            "
                                                        >
                                                            {{
                                                                content.live
                                                                    ? "Yes"
                                                                    : "No"
                                                            }}
                                                        </span>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-sm
                                                            text-gray-500
                                                        "
                                                    >
                                                        {{ content.target }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-sm
                                                            text-gray-500
                                                        "
                                                    >
                                                        {{content.exercise ? content.exercise.category : ''}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
    <dialog-model :show="open" @close="close">
        <template v-slot:title>
            <span class="capitalize">{{ title }} </span></template
        >
        <template v-slot:content>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div>
                    <label
                        for="format"
                        class="block text-sm font-medium text-gray-700"
                        >Exercise Format</label
                    >
                    <select
                        v-model="form.format"
                        id="format"
                        name="format"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select Exercise Format</option>
                        <option
                            v-for="format in formats"
                            :key="format.id"
                            :value="format.id"
                        >
                            {{ format.title }}
                        </option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.content.format"
                    />
                </div>
                <div>
                    <label
                        for="category"
                        class="block text-sm font-medium text-gray-700"
                        >Category</label
                    >
                    <select
                        v-model="form.category"
                        id="category"
                        name="category"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select category</option>
                        <option
                            v-for="category in categories"
                            :key="category.id"
                            :value="category.id"
                        >
                            {{ category.title }}
                        </option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.content.category"
                    />
                </div>
                <div>
                    <label
                        for="exercise"
                        class="block text-sm font-medium text-gray-700"
                        >Exercise</label
                    >
                    <select
                        v-model="form.exercise"
                        id="exercise"
                        name="exercise"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select Exercise</option>
                        <option
                            v-for="exercise in filter_exercises"
                            :key="exercise.id"
                            :value="exercise.id"
                        >
                            {{ exercise.title }}
                        </option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.content.exercise"
                    />
                </div>
                <div>
                    <label
                        for="exercise_order"
                        class="block text-sm font-medium text-gray-700"
                    >Exercise Order</label
                    >
                    <input
                        v-model="form.exercise_order"
                        type="number"
                        name="exercise_order"
                        id="exercise_order"
                        autocomplete="organization-title"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.content.exercise_order"
                    />
                </div>
                <div>
                    <label
                        for="exercise_group"
                        class="block text-sm font-medium text-gray-700"
                    >Exercise Group</label
                    >
                    <select
                        v-model="form.exercise_group"
                        id="live"
                        name="live"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select a part?</option>
                        <option v-for="(part, index) in exercisesGroup" :key="index" :value="part.slug">{{ part.title }}</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.content.exercise_group"
                    />
                </div>
                <div>
                    <label
                        for="target"
                        class="block text-sm font-medium text-gray-700"
                        >Target</label
                    >
                    <input
                        v-model="form.target"
                        type="number"
                        name="target"
                        id="target"
                        autocomplete="organization-title"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.content.target"
                    />
                </div>
                <div>
                    <label
                        for="live"
                        class="block text-sm font-medium text-gray-700"
                        >Live</label
                    >
                    <select
                        v-model="form.live"
                        id="live"
                        name="live"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Content is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.content.live"
                    />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button
                type="button"
                class="
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-4
                    py-2
                    bg-green-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-green-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-green-500
                    sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="submit()"
            >
                Save
            </button>
            <button
                type="button"
                class="
                    mt-3
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-gray-300
                    shadow-sm
                    px-4
                    py-2
                    bg-white
                    text-base
                    font-medium
                    text-gray-700
                    hover:bg-gray-50
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-indigo-500
                    sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="close()"
                ref="cancelButtonRef"
            >
                Cancel
            </button>
        </template>
    </dialog-model>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import DialogModel from "@/Components/DialogModel";
import InputError from "@/Components/InputError";
import { useForm } from "@inertiajs/inertia-vue3";
export default {
    data() {
        return {
            open: false,
            editItemIndex: -1,
            exercises: [],
            formats: [],
            categories: [],
            form: useForm(
                {
                    id: "",
                    format: "",
                    exercise: "",
                    category: "",
                    live: "",
                    target: "",
                    exercise_group: '',
                    exercise_order: '',
                },
                {
                    bag: "content",
                }
            ),
        };
    },
    computed: {
        filter_exercises() {
            if (this.form.format && this.form.category) {
                return this.exercises.filter((exercise) => {
                    return (
                        exercise.exercise_format_id ===
                            parseInt(this.form.format) &&
                        exercise.category_id === parseInt(this.form.category)
                    );
                });
            }
            return [];
        },
        title() {
            return this.editItemIndex > -1
                ? "Edit this Exercise."
                : "Add a new Exercise in Plan.";
        },
    },
    props: {
        contents: Array,
        exercisesGroup: Array,
        plan: Object,
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            axios
                .get(route("admin.plan.additional"))
                .then(({ data }) => {
                    (this.exercises = data.exercises),
                        (this.formats = data.formats),
                        (this.categories = data.categories);
                })
                .catch((err) => console.log(err));
        },
        close() {
            this.form.clearErrors();
            this.form.reset();
            this.open = false;
            this.editItemIndex = -1;
        },
        submit() {
            if (this.editItemIndex > -1) {
                // update request
                this.form.put(
                    route("admin.plans.content.update", {
                        plan: this.plan.id,
                        content: this.form.id,
                        plan_slug: route().params?.plan
                    }),
                    {
                        onSuccess: () => this.close(),
                        preserveScroll: true,
                    }
                );
            } else {
                // store request
                this.form.post(
                    route("admin.plans.content.store", {
                        plan: this.plan.id,
                        plan_slug: route().params?.plan
                    }),
                    {
                        onSuccess: () => this.close(),
                        preserveScroll: true,
                    }
                );
            }
        },
        edit(content) {
            console.log(content);
            this.editItemIndex = this.contents.indexOf(content);
            this.form.live = content.live ? 1 : 0;
            this.form.id = content.id;
            this.form.category = content.exercise.category_id;
            this.form.format = content.exercise.exercise_format_id;
            this.form.exercise = content.exercise.id;
            this.form.target = content.target;
            this.form.exercise_group = content.exercise_group;
            this.form.exercise_order = content.exercise_order;
            this.open = true;
        },
        destroy(plan,content){
            if(confirm('Are you sure about deleting this item?')){
                this.$inertia.delete(route(
                    `admin.plans.content.destroy`,
                    {
                        plan: plan.id,
                        content:
                        content.id,
                    }
                ))
            }
        }
    },
    components: {
        BreezeAuthenticatedLayout,
        DialogModel,
        InputError,
    },
};
</script>
